import styled, { css } from 'styled-components';

export const Container = styled.span<{ $isDue: boolean; $isBlob: boolean }>(
  ({ theme, $isDue, $isBlob }) => css`
    ${theme.typography.paragraph.s};
    color: ${$isDue ? ($isBlob ? theme.co.information40 : theme.co.warning10) : theme.co.success30};
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
  `,
);
